'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _semanticUiReact = require('semantic-ui-react');

var _asaCompliance = require('./../../utils/asa-compliance');

var _asaCompliance2 = _interopRequireDefault(_asaCompliance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsaComponent = function AsaComponent(_ref) {
  var text = _ref.text,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? '' : _ref$label;

  if ((0, _asaCompliance2.default)(text)) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' }),
      label
    );
  }
  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'grey' });
};

AsaComponent.propTypes = {
  text: _propTypes.PropTypes.string.isRequired,
  label: _propTypes.PropTypes.string
};

AsaComponent.defaultProps = {
  label: ''
};

exports.default = AsaComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/asa-compliance/index.js
 ** module id = 598
 ** module chunks = 0
 **/